import { Component, OnInit, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

@Component({
  selector: 'app-dados-colaborador',
  templateUrl: './dados-colaborador.component.html',
  styleUrls: ['./dados-colaborador.component.scss']
})
export class DadosColaboradorReadComponent implements OnInit {
  @Input() infos: any;

  unit$: Observable<any>;
  department$: Observable<any>;
  role$: Observable<any>;

  vinculo: string;
  departmentName: string;
  roleName: string;
  unitName: string;

  constructor(private store: Store<fromStore.DashboardState>) {}

  ngOnInit(): void {
    if (this.infos === undefined) {
      return;
    }
    this.dispatchActions();
  }

  dispatchActions(): void {
    this.store
      .select(fromStore.getDepartmentsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadDepartments());
        }
      });

    this.store
      .select(fromStore.getUnitsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadUnits());
        }
      });

    this.store
      .select(fromStore.getRolesLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadRoles());
        }
      });

    this.loadFromStore();
  }

  loadFromStore(): void {
    this.store
      .pipe(
        select(fromStore.getPaginatedUnits),
        filter(units => units.length >= 1)
      )
      .subscribe(units => {
        const unitUid = this.infos?.unit;
        const defaultUnit = {
          code: '01',
          name: 'Default Unit',
          safedoc: '',
          uid: 'c73885d0-052a-458e-aa29-9f52470300d1'
          }

        units = [defaultUnit, ...units]
        this.unitName = units.filter(u => u?.uid === unitUid)[0]?.name;
      });

    this.store
      .pipe(
        select(fromStore.getPaginatedDepartments),
        filter(departments => departments.length >= 1)
      )
      .subscribe(departments => {
        const departmentUid = this.infos?.department;
        const defaultDeparment = {
          code: '01',
          name: 'Default Department',
          safedoc: '',
          uid: '89b5c543-50a0-47b3-abe4-77398b768142'
          }
        departments = [defaultDeparment, ...departments]
        this.departmentName = departments.filter(d => d?.uid === departmentUid)[0]?.name;
      });

    this.store
      .pipe(
        select(fromStore.getPaginatedRoles),
        filter(roles => roles.length >= 1)
      )
      .subscribe(roles => {
        const roleUid = this.infos?.role;
        const defaultRole = {
          code: '01',
          name: 'Default Role',
          safedoc: '',
          uid: '1412d7fa-1905-43e5-92b7-f0b2c3699875'
          }
        roles = [defaultRole, ...roles]
        this.roleName = roles.filter(d => d?.uid === roleUid)[0]?.name;
      });
  }
}
